export const CompleteMatchesModalSkeleton = () => {
	return (
		<div className="space-y-5">
			<div className="w-full h-10 bg-gray-200 " />
			<div className="w-full h-10 bg-gray-200 " />
			<div className="w-full h-10 bg-gray-200 " />
			<div className="flex justify-end gap-5">
				<div className="w-32 h-10 bg-gray-200 " />
				<div className="w-32 h-10 bg-gray-200 " />
			</div>
		</div>
	);
};
